import moment from 'moment';

/** Raw Ant Design values; individual controls use strings, moments, booleans, or label/value objects. */
export type DetailsValues = Record<string, unknown>;

/** Select controls compare and persist identity rather than their presentation label. */
export function selectionID(value: unknown): string | undefined {
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') {
        const selection = value as {key?: string; _id?: string};
        return selection.key ?? selection._id;
    }
    return undefined;
}

/** Compares form values with saved values without treating moment instances or changed labels as edits. */
export function normalizedValue(field: string, value: unknown): string | boolean | undefined {
    if (field === 'setWeatherDelay') return Boolean(value);
    if (field === 'scheduledFlightDate' || field === 'estDepartureTime') {
        if (moment.isMoment(value)) {
            return value.format(field === 'scheduledFlightDate' ? 'YYYY-MM-DD' : 'HH:mm');
        }
        return typeof value === 'string'
            ? value.slice(0, field === 'scheduledFlightDate' ? 10 : 5)
            : undefined;
    }
    if (field.endsWith('ID') || field === 'lastKnownController') return selectionID(value);
    return value == null ? '' : String(value);
}
